module.exports = __webpack_public_path__ + "media/application/images/external-services/bigcommerce-logo-cfac077ffc877295949590b75c3f38c4.svg";